window.METADATA = {
  "positionProvince": {
    "subs": [{
      "count": 1415,
      "subs": [{
        "count": 1415,
        "subs": [],
        "name": "北京",
        "code": "30101"
      }],
      "name": "北京",
      "code": "301"
    }, {
      "count": 1318,
      "subs": [{
        "count": 802,
        "subs": [],
        "name": "深圳市",
        "code": "30816"
      }, {
        "count": 338,
        "subs": [],
        "name": "广州市",
        "code": "30805"
      }, {
        "count": 53,
        "subs": [],
        "name": "阳江市",
        "code": "30817"
      }, {
        "count": 43,
        "subs": [],
        "name": "东莞市",
        "code": "30803"
      }, {
        "count": 30,
        "subs": [],
        "name": "珠海市",
        "code": "30822"
      }, {
        "count": 20,
        "subs": [],
        "name": "佛山市",
        "code": "30804"
      }, {
        "count": 15,
        "subs": [],
        "name": "惠州市",
        "code": "30807"
      }, {
        "count": 3,
        "subs": [],
        "name": "江门市",
        "code": "30808"
      }, {
        "count": 3,
        "subs": [],
        "name": "肇庆市",
        "code": "30820"
      }, {
        "count": 3,
        "subs": [],
        "name": "中山市",
        "code": "30821"
      }, {
        "count": 2,
        "subs": [],
        "name": "梅州市",
        "code": "30811"
      }, {
        "count": 2,
        "subs": [],
        "name": "清远市",
        "code": "30812"
      }, {
        "count": 1,
        "subs": [],
        "name": "广东其他",
        "code": "30801"
      }, {
        "count": 1,
        "subs": [],
        "name": "揭阳市",
        "code": "30809"
      }, {
        "count": 1,
        "subs": [],
        "name": "汕头市",
        "code": "30813"
      }, {
        "count": 1,
        "subs": [],
        "name": "韶关市",
        "code": "30815"
      }, {
        "count": 1,
        "subs": [],
        "name": "湛江市",
        "code": "30819"
      }],
      "name": "广东省",
      "code": "308"
    }, {
      "count": 1232,
      "subs": [{
        "count": 1152,
        "subs": [],
        "name": "杭州市",
        "code": "33102"
      }, {
        "count": 28,
        "subs": [],
        "name": "绍兴市",
        "code": "33109"
      }, {
        "count": 23,
        "subs": [],
        "name": "宁波市",
        "code": "33107"
      }, {
        "count": 14,
        "subs": [],
        "name": "嘉兴市",
        "code": "33104"
      }, {
        "count": 5,
        "subs": [],
        "name": "台州市",
        "code": "33110"
      }, {
        "count": 4,
        "subs": [],
        "name": "金华市",
        "code": "33105"
      }, {
        "count": 3,
        "subs": [],
        "name": "浙江其他",
        "code": "33101"
      }, {
        "count": 3,
        "subs": [],
        "name": "温州市",
        "code": "33111"
      }],
      "name": "浙江省",
      "code": "331"
    }, {
      "count": 1200,
      "subs": [{
        "count": 1199,
        "subs": [],
        "name": "上海",
        "code": "30201"
      }],
      "name": "上海",
      "code": "302"
    }, {
      "count": 180,
      "subs": [{
        "count": 59,
        "subs": [],
        "name": "苏州市",
        "code": "31807"
      }, {
        "count": 35,
        "subs": [],
        "name": "南京市",
        "code": "31805"
      }, {
        "count": 20,
        "subs": [],
        "name": "江苏其他",
        "code": "31801"
      }, {
        "count": 17,
        "subs": [],
        "name": "无锡市",
        "code": "31809"
      }, {
        "count": 16,
        "subs": [],
        "name": "徐州市",
        "code": "31811"
      }, {
        "count": 7,
        "subs": [],
        "name": "南通市",
        "code": "31806"
      }, {
        "count": 5,
        "subs": [],
        "name": "连云港市",
        "code": "31804"
      }, {
        "count": 4,
        "subs": [],
        "name": "常州市",
        "code": "31802"
      }, {
        "count": 4,
        "subs": [],
        "name": "淮安市",
        "code": "31803"
      }, {
        "count": 4,
        "subs": [],
        "name": "泰州市",
        "code": "31808"
      }, {
        "count": 4,
        "subs": [],
        "name": "宿迁市",
        "code": "31810"
      }, {
        "count": 4,
        "subs": [],
        "name": "盐城市",
        "code": "31812"
      }, {
        "count": 1,
        "subs": [],
        "name": "扬州市",
        "code": "31813"
      }],
      "name": "江苏省",
      "code": "318"
    }, {
      "count": 150,
      "subs": [{
        "count": 71,
        "subs": [],
        "name": "厦门市",
        "code": "30609"
      }, {
        "count": 62,
        "subs": [],
        "name": "福州市",
        "code": "30602"
      }, {
        "count": 10,
        "subs": [],
        "name": "泉州市",
        "code": "30607"
      }, {
        "count": 5,
        "subs": [],
        "name": "福建其他",
        "code": "30601"
      }, {
        "count": 1,
        "subs": [],
        "name": "宁德市",
        "code": "30605"
      }, {
        "count": 1,
        "subs": [],
        "name": "莆田市",
        "code": "30606"
      }],
      "name": "福建省",
      "code": "306"
    }, {
      "count": 127,
      "subs": [{
        "count": 102,
        "subs": [],
        "name": "成都市",
        "code": "32704"
      }, {
        "count": 24,
        "subs": [],
        "name": "绵阳市",
        "code": "32714"
      }, {
        "count": 1,
        "subs": [],
        "name": "四川其他",
        "code": "32701"
      }],
      "name": "四川省",
      "code": "327"
    }, {
      "count": 119,
      "subs": [{
        "count": 29,
        "subs": [],
        "name": "南昌市",
        "code": "31907"
      }, {
        "count": 12,
        "subs": [],
        "name": "江西其他",
        "code": "31901"
      }, {
        "count": 8,
        "subs": [],
        "name": "抚州市",
        "code": "31902"
      }, {
        "count": 8,
        "subs": [],
        "name": "吉安市",
        "code": "31904"
      }, {
        "count": 8,
        "subs": [],
        "name": "景德镇市",
        "code": "31905"
      }, {
        "count": 8,
        "subs": [],
        "name": "九江市",
        "code": "31906"
      }, {
        "count": 8,
        "subs": [],
        "name": "萍乡市",
        "code": "31908"
      }, {
        "count": 8,
        "subs": [],
        "name": "上饶市",
        "code": "31909"
      }, {
        "count": 8,
        "subs": [],
        "name": "新余市",
        "code": "31910"
      }, {
        "count": 8,
        "subs": [],
        "name": "宜春市",
        "code": "31911"
      }, {
        "count": 8,
        "subs": [],
        "name": "鹰潭市",
        "code": "31912"
      }, {
        "count": 6,
        "subs": [],
        "name": "赣州市",
        "code": "31903"
      }],
      "name": "江西省",
      "code": "319"
    }, {
      "count": 46,
      "subs": [{
        "count": 46,
        "subs": [],
        "name": "重庆",
        "code": "30401"
      }],
      "name": "重庆",
      "code": "304"
    }, {
      "count": 42,
      "subs": [{
        "count": 28,
        "subs": [],
        "name": "济南市",
        "code": "32406"
      }, {
        "count": 9,
        "subs": [],
        "name": "青岛市",
        "code": "32411"
      }, {
        "count": 2,
        "subs": [],
        "name": "威海市",
        "code": "32414"
      }, {
        "count": 1,
        "subs": [],
        "name": "济宁市",
        "code": "32407"
      }, {
        "count": 1,
        "subs": [],
        "name": "泰安市",
        "code": "32413"
      }, {
        "count": 1,
        "subs": [],
        "name": "烟台市",
        "code": "32416"
      }],
      "name": "山东省",
      "code": "324"
    }, {
      "count": 42,
      "subs": [{
        "count": 20,
        "subs": [],
        "name": "保定市",
        "code": "31202"
      }, {
        "count": 12,
        "subs": [],
        "name": "石家庄市",
        "code": "31209"
      }, {
        "count": 4,
        "subs": [],
        "name": "廊坊市",
        "code": "31207"
      }, {
        "count": 3,
        "subs": [],
        "name": "河北其他",
        "code": "31201"
      }, {
        "count": 1,
        "subs": [],
        "name": "沧州市",
        "code": "31203"
      }, {
        "count": 1,
        "subs": [],
        "name": "承德市",
        "code": "31204"
      }, {
        "count": 1,
        "subs": [],
        "name": "邢台市",
        "code": "31211"
      }],
      "name": "河北省",
      "code": "312"
    }, {
      "count": 35,
      "subs": [{
        "count": 33,
        "subs": [],
        "name": "西安市",
        "code": "32608"
      }, {
        "count": 1,
        "subs": [],
        "name": "汉中市",
        "code": "32604"
      }, {
        "count": 1,
        "subs": [],
        "name": "延安市",
        "code": "32610"
      }],
      "name": "陕西省",
      "code": "326"
    }, {
      "count": 31,
      "subs": [{
        "count": 31,
        "subs": [],
        "name": "武汉市",
        "code": "31513"
      }],
      "name": "湖北省",
      "code": "315"
    }, {
      "count": 31,
      "subs": [{
        "count": 22,
        "subs": [],
        "name": "长沙市",
        "code": "31614"
      }, {
        "count": 5,
        "subs": [],
        "name": "湘潭市",
        "code": "31608"
      }, {
        "count": 3,
        "subs": [],
        "name": "株洲市",
        "code": "31615"
      }, {
        "count": 1,
        "subs": [],
        "name": "常德市",
        "code": "31602"
      }],
      "name": "湖南省",
      "code": "316"
    }, {
      "count": 27,
      "subs": [{
        "count": 14,
        "subs": [],
        "name": "合肥市",
        "code": "30508"
      }, {
        "count": 6,
        "subs": [],
        "name": "安庆市",
        "code": "30502"
      }, {
        "count": 4,
        "subs": [],
        "name": "芜湖市",
        "code": "30515"
      }, {
        "count": 2,
        "subs": [],
        "name": "蚌埠市",
        "code": "30503"
      }, {
        "count": 1,
        "subs": [],
        "name": "滁州市",
        "code": "30506"
      }],
      "name": "安徽省",
      "code": "305"
    }, {
      "count": 21,
      "subs": [{
        "count": 16,
        "subs": [],
        "name": "郑州市",
        "code": "31317"
      }, {
        "count": 3,
        "subs": [],
        "name": "驻马店市",
        "code": "31319"
      }, {
        "count": 1,
        "subs": [],
        "name": "南阳市",
        "code": "31309"
      }, {
        "count": 1,
        "subs": [],
        "name": "许昌市",
        "code": "31316"
      }],
      "name": "河南省",
      "code": "313"
    }, {
      "count": 15,
      "subs": [{
        "count": 15,
        "subs": [],
        "name": "天津",
        "code": "30301"
      }],
      "name": "天津",
      "code": "303"
    }, {
      "count": 10,
      "subs": [{
        "count": 5,
        "subs": [],
        "name": "大连市",
        "code": "32005"
      }, {
        "count": 4,
        "subs": [],
        "name": "沈阳市",
        "code": "32013"
      }, {
        "count": 1,
        "subs": [],
        "name": "锦州市",
        "code": "32010"
      }],
      "name": "辽宁省",
      "code": "320"
    }, {
      "count": 7,
      "subs": [{
        "count": 3,
        "subs": [],
        "name": "香港岛",
        "code": "33203"
      }, {
        "count": 2,
        "subs": [],
        "name": "香港",
        "code": "33201"
      }, {
        "count": 2,
        "subs": [],
        "name": "新界",
        "code": "33204"
      }],
      "name": "香港",
      "code": "332"
    }, {
      "count": 7,
      "subs": [{
        "count": 7,
        "subs": [],
        "name": "昆明市",
        "code": "33008"
      }],
      "name": "云南省",
      "code": "330"
    }, {
      "count": 7,
      "subs": [{
        "count": 3,
        "subs": [],
        "name": "南宁市",
        "code": "30912"
      }, {
        "count": 2,
        "subs": [],
        "name": "广西其他",
        "code": "30901"
      }, {
        "count": 1,
        "subs": [],
        "name": "百色市",
        "code": "30902"
      }, {
        "count": 1,
        "subs": [],
        "name": "柳州市",
        "code": "30911"
      }],
      "name": "广西省",
      "code": "309"
    }, {
      "count": 6,
      "subs": [{
        "count": 4,
        "subs": [],
        "name": "长春市",
        "code": "31710"
      }, {
        "count": 1,
        "subs": [],
        "name": "吉林其他",
        "code": "31701"
      }, {
        "count": 1,
        "subs": [],
        "name": "吉林市",
        "code": "31704"
      }],
      "name": "吉林省",
      "code": "317"
    }, {
      "count": 5,
      "subs": [{
        "count": 4,
        "subs": [],
        "name": "兰州市",
        "code": "30708"
      }, {
        "count": 1,
        "subs": [],
        "name": "天水市",
        "code": "30713"
      }],
      "name": "甘肃省",
      "code": "307"
    }, {
      "count": 4,
      "subs": [{
        "count": 4,
        "subs": [],
        "name": "海口市",
        "code": "31109"
      }],
      "name": "海南省",
      "code": "311"
    }, {
      "count": 4,
      "subs": [{
        "count": 4,
        "subs": [],
        "name": "贵阳市",
        "code": "31004"
      }],
      "name": "贵州省",
      "code": "310"
    }, {
      "count": 3,
      "subs": [{
        "count": 3,
        "subs": [],
        "name": "吕梁市",
        "code": "32506"
      }],
      "name": "山西省",
      "code": "325"
    }, {
      "count": 3,
      "subs": [{
        "count": 2,
        "subs": [],
        "name": "巴彦淖尔市",
        "code": "32103"
      }, {
        "count": 1,
        "subs": [],
        "name": "呼和浩特市",
        "code": "32107"
      }],
      "name": "内蒙古",
      "code": "321"
    }, {
      "count": 2,
      "subs": [{
        "count": 2,
        "subs": [],
        "name": "哈尔滨市",
        "code": "31404"
      }],
      "name": "黑龙江省",
      "code": "314"
    }, {
      "count": 1,
      "subs": [{
        "count": 1,
        "subs": [],
        "name": "西宁市",
        "code": "32308"
      }],
      "name": "青海省",
      "code": "323"
    }, {
      "count": 1,
      "subs": [{
        "count": 1,
        "subs": [],
        "name": "乌鲁木齐市",
        "code": "32916"
      }],
      "name": "新疆",
      "code": "329"
    }]
  },
  "citys": {
    31001: {
      "id": 31001,
      "name": "贵州其他",
      "provinceId": 310
    },
    32712: {
      "id": 32712,
      "name": "泸州市",
      "provinceId": 327
    },
    32409: {
      "id": 32409,
      "name": "聊城市",
      "provinceId": 324
    },
    32205: {
      "id": 32205,
      "name": "银川市",
      "provinceId": 322
    },
    32004: {
      "id": 32004,
      "name": "朝阳市",
      "provinceId": 320
    },
    30513: {
      "id": 30513,
      "name": "马鞍山市",
      "provinceId": 305
    },
    30815: {
      "id": 30815,
      "name": "韶关市",
      "provinceId": 308
    },
    32003: {
      "id": 32003,
      "name": "本溪市",
      "provinceId": 320
    },
    30506: {
      "id": 30506,
      "name": "滁州市",
      "provinceId": 305
    },
    31903: {
      "id": 31903,
      "name": "赣州市",
      "provinceId": 319
    },
    31316: {
      "id": 31316,
      "name": "许昌市",
      "provinceId": 313
    },
    31104: {
      "id": 31104,
      "name": "昌江黎族自治县",
      "provinceId": 311
    },
    31502: {
      "id": 31502,
      "name": "鄂州市",
      "provinceId": 315
    },
    30503: {
      "id": 30503,
      "name": "蚌埠市",
      "provinceId": 305
    },
    32101: {
      "id": 32101,
      "name": "内蒙古其他",
      "provinceId": 321
    },
    32604: {
      "id": 32604,
      "name": "汉中市",
      "provinceId": 326
    },
    31911: {
      "id": 31911,
      "name": "宜春市",
      "provinceId": 319
    },
    31212: {
      "id": 31212,
      "name": "张家口市",
      "provinceId": 312
    },
    31409: {
      "id": 31409,
      "name": "牡丹江市",
      "provinceId": 314
    },
    31807: {
      "id": 31807,
      "name": "苏州市",
      "provinceId": 318
    },
    30609: {
      "id": 30609,
      "name": "厦门市",
      "provinceId": 306
    },
    31204: {
      "id": 31204,
      "name": "承德市",
      "provinceId": 312
    },
    33402: {
      "id": 33402,
      "name": "高雄市",
      "provinceId": 334
    },
    30516: {
      "id": 30516,
      "name": "宿州市",
      "provinceId": 305
    },
    31703: {
      "id": 31703,
      "name": "白山市",
      "provinceId": 317
    },
    30602: {
      "id": 30602,
      "name": "福州市",
      "provinceId": 306
    },
    33012: {
      "id": 33012,
      "name": "普洱市",
      "provinceId": 330
    },
    30902: {
      "id": 30902,
      "name": "百色市",
      "provinceId": 309
    },
    32703: {
      "id": 32703,
      "name": "巴中市",
      "provinceId": 327
    },
    31203: {
      "id": 31203,
      "name": "沧州市",
      "provinceId": 312
    },
    32705: {
      "id": 32705,
      "name": "达州市",
      "provinceId": 327
    },
    33005: {
      "id": 33005,
      "name": "德宏傣族景颇族自治州",
      "provinceId": 330
    },
    32903: {
      "id": 32903,
      "name": "阿克苏地区",
      "provinceId": 329
    },
    31402: {
      "id": 31402,
      "name": "大兴安岭地区",
      "provinceId": 314
    },
    32509: {
      "id": 32509,
      "name": "忻州市",
      "provinceId": 325
    },
    32805: {
      "id": 32805,
      "name": "林芝地区",
      "provinceId": 328
    },
    32603: {
      "id": 32603,
      "name": "宝鸡市",
      "provinceId": 326
    },
    32611: {
      "id": 32611,
      "name": "榆林市",
      "provinceId": 326
    },
    33015: {
      "id": 33015,
      "name": "西双版纳傣族自治州",
      "provinceId": 330
    },
    32410: {
      "id": 32410,
      "name": "临沂市",
      "provinceId": 324
    },
    33202: {
      "id": 33202,
      "name": "九龙",
      "provinceId": 332
    },
    32308: {
      "id": 32308,
      "name": "西宁市",
      "provinceId": 323
    },
    30911: {
      "id": 30911,
      "name": "柳州市",
      "provinceId": 309
    },
    32510: {
      "id": 32510,
      "name": "阳泉市",
      "provinceId": 325
    },
    30906: {
      "id": 30906,
      "name": "贵港市",
      "provinceId": 309
    },
    31303: {
      "id": 31303,
      "name": "鹤壁市",
      "provinceId": 313
    },
    32014: {
      "id": 32014,
      "name": "铁岭市",
      "provinceId": 320
    },
    33112: {
      "id": 33112,
      "name": "舟山市",
      "provinceId": 331
    },
    30808: {
      "id": 30808,
      "name": "江门市",
      "provinceId": 308
    },
    31601: {
      "id": 31601,
      "name": "湖南其他",
      "provinceId": 316
    },
    31113: {
      "id": 31113,
      "name": "琼海市",
      "provinceId": 311
    },
    30709: {
      "id": 30709,
      "name": "临夏回族自治州",
      "provinceId": 307
    },
    31004: {
      "id": 31004,
      "name": "贵阳市",
      "provinceId": 310
    },
    31517: {
      "id": 31517,
      "name": "孝感市",
      "provinceId": 315
    },
    32914: {
      "id": 32914,
      "name": "石河子市",
      "provinceId": 329
    },
    32601: {
      "id": 32601,
      "name": "陕西其他",
      "provinceId": 326
    },
    32904: {
      "id": 32904,
      "name": "阿拉尔市",
      "provinceId": 329
    },
    31002: {
      "id": 31002,
      "name": "安顺市",
      "provinceId": 310
    },
    32204: {
      "id": 32204,
      "name": "吴忠市",
      "provinceId": 322
    },
    31315: {
      "id": 31315,
      "name": "信阳市",
      "provinceId": 313
    },
    31813: {
      "id": 31813,
      "name": "扬州市",
      "provinceId": 318
    },
    30607: {
      "id": 30607,
      "name": "泉州市",
      "provinceId": 306
    },
    32704: {
      "id": 32704,
      "name": "成都市",
      "provinceId": 327
    },
    30816: {
      "id": 30816,
      "name": "深圳市",
      "provinceId": 308
    },
    31211: {
      "id": 31211,
      "name": "邢台市",
      "provinceId": 312
    },
    31007: {
      "id": 31007,
      "name": "黔南布依族苗族自治州",
      "provinceId": 310
    },
    32109: {
      "id": 32109,
      "name": "通辽市",
      "provinceId": 321
    },
    31706: {
      "id": 31706,
      "name": "四平市",
      "provinceId": 317
    },
    33107: {
      "id": 33107,
      "name": "宁波市",
      "provinceId": 331
    },
    32804: {
      "id": 32804,
      "name": "拉萨市",
      "provinceId": 328
    },
    30702: {
      "id": 30702,
      "name": "白银市",
      "provinceId": 307
    },
    33401: {
      "id": 33401,
      "name": "台湾",
      "provinceId": 334
    },
    31904: {
      "id": 31904,
      "name": "吉安市",
      "provinceId": 319
    },
    31709: {
      "id": 31709,
      "name": "延边朝鲜族自治州",
      "provinceId": 317
    },
    31511: {
      "id": 31511,
      "name": "随州市",
      "provinceId": 315
    },
    32506: {
      "id": 32506,
      "name": "吕梁市",
      "provinceId": 325
    },
    31306: {
      "id": 31306,
      "name": "开封市",
      "provinceId": 313
    },
    30504: {
      "id": 30504,
      "name": "亳州市",
      "provinceId": 305
    },
    31101: {
      "id": 31101,
      "name": "海南其他",
      "provinceId": 311
    },
    32610: {
      "id": 32610,
      "name": "延安市",
      "provinceId": 326
    },
    33201: {
      "id": 33201,
      "name": "香港",
      "provinceId": 332
    },
    30514: {
      "id": 30514,
      "name": "铜陵市",
      "provinceId": 305
    },
    31610: {
      "id": 31610,
      "name": "益阳市",
      "provinceId": 316
    },
    32001: {
      "id": 32001,
      "name": "辽宁其他",
      "provinceId": 320
    },
    31205: {
      "id": 31205,
      "name": "邯郸市",
      "provinceId": 312
    },
    33004: {
      "id": 33004,
      "name": "大理白族自治州",
      "provinceId": 330
    },
    31102: {
      "id": 31102,
      "name": "白沙黎族自治县",
      "provinceId": 311
    },
    30802: {
      "id": 30802,
      "name": "潮州市",
      "provinceId": 308
    },
    32007: {
      "id": 32007,
      "name": "抚顺市",
      "provinceId": 320
    },
    30701: {
      "id": 30701,
      "name": "甘肃其他",
      "provinceId": 307
    },
    32722: {
      "id": 32722,
      "name": "自贡市",
      "provinceId": 327
    },
    33013: {
      "id": 33013,
      "name": "曲靖市",
      "provinceId": 330
    },
    32411: {
      "id": 32411,
      "name": "青岛市",
      "provinceId": 324
    },
    33014: {
      "id": 33014,
      "name": "文山壮族苗族自治州",
      "provinceId": 330
    },
    32713: {
      "id": 32713,
      "name": "眉山市",
      "provinceId": 327
    },
    31602: {
      "id": 31602,
      "name": "常德市",
      "provinceId": 316
    },
    31114: {
      "id": 31114,
      "name": "琼中黎族苗族自治县",
      "provinceId": 311
    },
    32404: {
      "id": 32404,
      "name": "东营市",
      "provinceId": 324
    },
    33104: {
      "id": 33104,
      "name": "嘉兴市",
      "provinceId": 331
    },
    32913: {
      "id": 32913,
      "name": "克孜勒苏柯尔克孜自治州",
      "provinceId": 329
    },
    30710: {
      "id": 30710,
      "name": "陇南市",
      "provinceId": 307
    },
    33204: {
      "id": 33204,
      "name": "新界",
      "provinceId": 332
    },
    31512: {
      "id": 31512,
      "name": "天门市",
      "provinceId": 315
    },
    30807: {
      "id": 30807,
      "name": "惠州市",
      "provinceId": 308
    },
    31501: {
      "id": 31501,
      "name": "湖北其他",
      "provinceId": 315
    },
    33301: {
      "id": 33301,
      "name": "澳门",
      "provinceId": 333
    },
    31010: {
      "id": 31010,
      "name": "遵义市",
      "provinceId": 310
    },
    31408: {
      "id": 31408,
      "name": "佳木斯市",
      "provinceId": 314
    },
    30903: {
      "id": 30903,
      "name": "北海市",
      "provinceId": 309
    },
    31120: {
      "id": 31120,
      "name": "五指山市",
      "provinceId": 311
    },
    31318: {
      "id": 31318,
      "name": "周口市",
      "provinceId": 313
    },
    31814: {
      "id": 31814,
      "name": "镇江市",
      "provinceId": 318
    },
    32707: {
      "id": 32707,
      "name": "甘孜藏族自治州",
      "provinceId": 327
    },
    30601: {
      "id": 30601,
      "name": "福建其他",
      "provinceId": 306
    },
    32203: {
      "id": 32203,
      "name": "石嘴山市",
      "provinceId": 322
    },
    32309: {
      "id": 32309,
      "name": "玉树藏族自治州",
      "provinceId": 323
    },
    30810: {
      "id": 30810,
      "name": "茂名市",
      "provinceId": 308
    },
    31609: {
      "id": 31609,
      "name": "湘西土家族苗族自治州",
      "provinceId": 316
    },
    31111: {
      "id": 31111,
      "name": "临高县",
      "provinceId": 311
    },
    32412: {
      "id": 32412,
      "name": "日照市",
      "provinceId": 324
    },
    31106: {
      "id": 31106,
      "name": "儋州市",
      "provinceId": 311
    },
    32507: {
      "id": 32507,
      "name": "朔州市",
      "provinceId": 325
    },
    31701: {
      "id": 31701,
      "name": "吉林其他",
      "provinceId": 317
    },
    30821: {
      "id": 30821,
      "name": "中山市",
      "provinceId": 308
    },
    32714: {
      "id": 32714,
      "name": "绵阳市",
      "provinceId": 327
    },
    31905: {
      "id": 31905,
      "name": "景德镇市",
      "provinceId": 319
    },
    32302: {
      "id": 32302,
      "name": "果洛藏族自治州",
      "provinceId": 323
    },
    30505: {
      "id": 30505,
      "name": "池州市",
      "provinceId": 305
    },
    32721: {
      "id": 32721,
      "name": "资阳市",
      "provinceId": 327
    },
    32602: {
      "id": 32602,
      "name": "安康市",
      "provinceId": 326
    },
    33404: {
      "id": 33404,
      "name": "嘉义市",
      "provinceId": 334
    },
    32609: {
      "id": 32609,
      "name": "咸阳市",
      "provinceId": 326
    },
    32908: {
      "id": 32908,
      "name": "昌吉回族自治州",
      "provinceId": 329
    },
    32301: {
      "id": 32301,
      "name": "青海其他",
      "provinceId": 323
    },
    32807: {
      "id": 32807,
      "name": "日喀则地区",
      "provinceId": 328
    },
    30610: {
      "id": 30610,
      "name": "漳州市",
      "provinceId": 306
    },
    31805: {
      "id": 31805,
      "name": "南京市",
      "provinceId": 318
    },
    32006: {
      "id": 32006,
      "name": "丹东市",
      "provinceId": 320
    },
    33203: {
      "id": 33203,
      "name": "香港岛",
      "provinceId": 332
    },
    32403: {
      "id": 32403,
      "name": "德州市",
      "provinceId": 324
    },
    32107: {
      "id": 32107,
      "name": "呼和浩特市",
      "provinceId": 321
    },
    31310: {
      "id": 31310,
      "name": "平顶山市",
      "provinceId": 313
    },
    31504: {
      "id": 31504,
      "name": "黄冈市",
      "provinceId": 315
    },
    30813: {
      "id": 30813,
      "name": "汕头市",
      "provinceId": 308
    },
    31509: {
      "id": 31509,
      "name": "神农架林区",
      "provinceId": 315
    },
    33105: {
      "id": 33105,
      "name": "金华市",
      "provinceId": 331
    },
    32015: {
      "id": 32015,
      "name": "营口市",
      "provinceId": 320
    },
    31414: {
      "id": 31414,
      "name": "伊春市",
      "provinceId": 314
    },
    32106: {
      "id": 32106,
      "name": "鄂尔多斯市",
      "provinceId": 321
    },
    31009: {
      "id": 31009,
      "name": "铜仁市",
      "provinceId": 310
    },
    32915: {
      "id": 32915,
      "name": "图木舒克市",
      "provinceId": 329
    },
    30512: {
      "id": 30512,
      "name": "六安市",
      "provinceId": 305
    },
    31804: {
      "id": 31804,
      "name": "连云港市",
      "provinceId": 318
    },
    32901: {
      "id": 32901,
      "name": "新疆其他",
      "provinceId": 329
    },
    31301: {
      "id": 31301,
      "name": "河南其他",
      "provinceId": 313
    },
    31407: {
      "id": 31407,
      "name": "鸡西市",
      "provinceId": 314
    },
    33302: {
      "id": 33302,
      "name": "澳门半岛",
      "provinceId": 333
    },
    31317: {
      "id": 31317,
      "name": "郑州市",
      "provinceId": 313
    },
    32715: {
      "id": 32715,
      "name": "南充市",
      "provinceId": 327
    },
    33109: {
      "id": 33109,
      "name": "绍兴市",
      "provinceId": 331
    },
    33006: {
      "id": 33006,
      "name": "迪庆藏族自治州",
      "provinceId": 330
    },
    32512: {
      "id": 32512,
      "name": "长治市",
      "provinceId": 325
    },
    31405: {
      "id": 31405,
      "name": "鹤岗市",
      "provinceId": 314
    },
    30908: {
      "id": 30908,
      "name": "河池市",
      "provinceId": 309
    },
    31515: {
      "id": 31515,
      "name": "咸宁市",
      "provinceId": 315
    },
    31906: {
      "id": 31906,
      "name": "九江市",
      "provinceId": 319
    },
    31612: {
      "id": 31612,
      "name": "岳阳市",
      "provinceId": 316
    },
    30913: {
      "id": 30913,
      "name": "钦州市",
      "provinceId": 309
    },
    30604: {
      "id": 30604,
      "name": "南平市",
      "provinceId": 306
    },
    32009: {
      "id": 32009,
      "name": "葫芦岛市",
      "provinceId": 320
    },
    31119: {
      "id": 31119,
      "name": "文昌市",
      "provinceId": 311
    },
    32303: {
      "id": 32303,
      "name": "海北藏族自治州",
      "provinceId": 323
    },
    33102: {
      "id": 33102,
      "name": "杭州市",
      "provinceId": 331
    },
    31704: {
      "id": 31704,
      "name": "吉林市",
      "provinceId": 317
    },
    31206: {
      "id": 31206,
      "name": "衡水市",
      "provinceId": 312
    },
    30511: {
      "id": 30511,
      "name": "黄山市",
      "provinceId": 305
    },
    30822: {
      "id": 30822,
      "name": "珠海市",
      "provinceId": 308
    },
    32406: {
      "id": 32406,
      "name": "济南市",
      "provinceId": 324
    },
    30711: {
      "id": 30711,
      "name": "平凉市",
      "provinceId": 307
    },
    31105: {
      "id": 31105,
      "name": "澄迈县",
      "provinceId": 311
    },
    31518: {
      "id": 31518,
      "name": "宜昌市",
      "provinceId": 315
    },
    31603: {
      "id": 31603,
      "name": "郴州市",
      "provinceId": 316
    },
    31510: {
      "id": 31510,
      "name": "十堰市",
      "provinceId": 315
    },
    30712: {
      "id": 30712,
      "name": "庆阳市",
      "provinceId": 307
    },
    32902: {
      "id": 32902,
      "name": "吐鲁番地区",
      "provinceId": 329
    },
    32413: {
      "id": 32413,
      "name": "泰安市",
      "provinceId": 324
    },
    30811: {
      "id": 30811,
      "name": "梅州市",
      "provinceId": 308
    },
    30814: {
      "id": 30814,
      "name": "汕尾市",
      "provinceId": 308
    },
    31005: {
      "id": 31005,
      "name": "六盘水市",
      "provinceId": 310
    },
    30703: {
      "id": 30703,
      "name": "定西市",
      "provinceId": 307
    },
    31708: {
      "id": 31708,
      "name": "通化市",
      "provinceId": 317
    },
    32916: {
      "id": 32916,
      "name": "乌鲁木齐市",
      "provinceId": 329
    },
    31307: {
      "id": 31307,
      "name": "洛阳市",
      "provinceId": 313
    },
    32720: {
      "id": 32720,
      "name": "宜宾市",
      "provinceId": 327
    },
    31304: {
      "id": 31304,
      "name": "济源市",
      "provinceId": 313
    },
    31812: {
      "id": 31812,
      "name": "盐城市",
      "provinceId": 318
    },
    33405: {
      "id": 33405,
      "name": "台北市",
      "provinceId": 334
    },
    33403: {
      "id": 33403,
      "name": "基隆市",
      "provinceId": 334
    },
    32706: {
      "id": 32706,
      "name": "德阳市",
      "provinceId": 327
    },
    31803: {
      "id": 31803,
      "name": "淮安市",
      "provinceId": 318
    },
    32008: {
      "id": 32008,
      "name": "阜新市",
      "provinceId": 320
    },
    31008: {
      "id": 31008,
      "name": "黔西南布依族苗族自治州",
      "provinceId": 310
    },
    31907: {
      "id": 31907,
      "name": "南昌市",
      "provinceId": 319
    },
    31507: {
      "id": 31507,
      "name": "荆州市",
      "provinceId": 315
    },
    32806: {
      "id": 32806,
      "name": "那曲地区",
      "provinceId": 328
    },
    31413: {
      "id": 31413,
      "name": "绥化市",
      "provinceId": 314
    },
    30905: {
      "id": 30905,
      "name": "防城港市",
      "provinceId": 309
    },
    33007: {
      "id": 33007,
      "name": "红河哈尼族彝族自治州",
      "provinceId": 330
    },
    30706: {
      "id": 30706,
      "name": "金昌市",
      "provinceId": 307
    },
    32111: {
      "id": 32111,
      "name": "乌兰察布市",
      "provinceId": 321
    },
    33103: {
      "id": 33103,
      "name": "湖州市",
      "provinceId": 331
    },
    31503: {
      "id": 31503,
      "name": "恩施土家族苗族自治州",
      "provinceId": 315
    },
    30819: {
      "id": 30819,
      "name": "湛江市",
      "provinceId": 308
    },
    32907: {
      "id": 32907,
      "name": "博尔塔拉蒙古自治州",
      "provinceId": 329
    },
    30713: {
      "id": 30713,
      "name": "天水市",
      "provinceId": 307
    },
    30804: {
      "id": 30804,
      "name": "佛山市",
      "provinceId": 308
    },
    32719: {
      "id": 32719,
      "name": "雅安市",
      "provinceId": 327
    },
    32808: {
      "id": 32808,
      "name": "山南地区",
      "provinceId": 328
    },
    33108: {
      "id": 33108,
      "name": "衢州市",
      "provinceId": 331
    },
    31112: {
      "id": 31112,
      "name": "陵水黎族自治县",
      "provinceId": 311
    },
    32801: {
      "id": 32801,
      "name": "西藏其他",
      "provinceId": 328
    },
    32414: {
      "id": 32414,
      "name": "威海市",
      "provinceId": 324
    },
    31604: {
      "id": 31604,
      "name": "衡阳市",
      "provinceId": 316
    },
    32405: {
      "id": 32405,
      "name": "菏泽市",
      "provinceId": 324
    },
    31406: {
      "id": 31406,
      "name": "黑河市",
      "provinceId": 314
    },
    32504: {
      "id": 32504,
      "name": "晋中市",
      "provinceId": 325
    },
    32104: {
      "id": 32104,
      "name": "包头市",
      "provinceId": 321
    },
    31611: {
      "id": 31611,
      "name": "永州市",
      "provinceId": 316
    },
    31802: {
      "id": 31802,
      "name": "常州市",
      "provinceId": 318
    },
    32608: {
      "id": 32608,
      "name": "西安市",
      "provinceId": 326
    },
    30509: {
      "id": 30509,
      "name": "淮北市",
      "provinceId": 305
    },
    31702: {
      "id": 31702,
      "name": "白城市",
      "provinceId": 317
    },
    30603: {
      "id": 30603,
      "name": "龙岩市",
      "provinceId": 306
    },
    31811: {
      "id": 31811,
      "name": "徐州市",
      "provinceId": 318
    },
    30914: {
      "id": 30914,
      "name": "梧州市",
      "provinceId": 309
    },
    31705: {
      "id": 31705,
      "name": "辽源市",
      "provinceId": 317
    },
    32408: {
      "id": 32408,
      "name": "莱芜市",
      "provinceId": 324
    },
    30801: {
      "id": 30801,
      "name": "广东其他",
      "provinceId": 308
    },
    31311: {
      "id": 31311,
      "name": "濮阳市",
      "provinceId": 313
    },
    31207: {
      "id": 31207,
      "name": "廊坊市",
      "provinceId": 312
    },
    31108: {
      "id": 31108,
      "name": "东方市",
      "provinceId": 311
    },
    32401: {
      "id": 32401,
      "name": "山东其他",
      "provinceId": 324
    },
    32718: {
      "id": 32718,
      "name": "遂宁市",
      "provinceId": 327
    },
    31208: {
      "id": 31208,
      "name": "秦皇岛市",
      "provinceId": 312
    },
    32415: {
      "id": 32415,
      "name": "潍坊市",
      "provinceId": 324
    },
    32201: {
      "id": 32201,
      "name": "宁夏其他",
      "provinceId": 322
    },
    30606: {
      "id": 30606,
      "name": "莆田市",
      "provinceId": 306
    },
    32709: {
      "id": 32709,
      "name": "广元市",
      "provinceId": 327
    },
    32505: {
      "id": 32505,
      "name": "临汾市",
      "provinceId": 325
    },
    33406: {
      "id": 33406,
      "name": "台南市",
      "provinceId": 334
    },
    31615: {
      "id": 31615,
      "name": "株洲市",
      "provinceId": 316
    },
    31201: {
      "id": 31201,
      "name": "河北其他",
      "provinceId": 312
    },
    32708: {
      "id": 32708,
      "name": "广安市",
      "provinceId": 327
    },
    31801: {
      "id": 31801,
      "name": "江苏其他",
      "provinceId": 318
    },
    32105: {
      "id": 32105,
      "name": "赤峰市",
      "provinceId": 321
    },
    30714: {
      "id": 30714,
      "name": "武威市",
      "provinceId": 307
    },
    32917: {
      "id": 32917,
      "name": "五家渠市",
      "provinceId": 329
    },
    30820: {
      "id": 30820,
      "name": "肇庆市",
      "provinceId": 308
    },
    33001: {
      "id": 33001,
      "name": "云南其他",
      "provinceId": 330
    },
    31403: {
      "id": 31403,
      "name": "大庆市",
      "provinceId": 314
    },
    32607: {
      "id": 32607,
      "name": "渭南市",
      "provinceId": 326
    },
    31508: {
      "id": 31508,
      "name": "潜江市",
      "provinceId": 315
    },
    31109: {
      "id": 31109,
      "name": "海口市",
      "provinceId": 311
    },
    32910: {
      "id": 32910,
      "name": "和田地区",
      "provinceId": 329
    },
    31506: {
      "id": 31506,
      "name": "荆门市",
      "provinceId": 315
    },
    30812: {
      "id": 30812,
      "name": "清远市",
      "provinceId": 308
    },
    30502: {
      "id": 30502,
      "name": "安庆市",
      "provinceId": 305
    },
    31118: {
      "id": 31118,
      "name": "万宁市",
      "provinceId": 311
    },
    33008: {
      "id": 33008,
      "name": "昆明市",
      "provinceId": 330
    },
    31513: {
      "id": 31513,
      "name": "武汉市",
      "provinceId": 315
    },
    31412: {
      "id": 31412,
      "name": "双鸭山市",
      "provinceId": 314
    },
    31605: {
      "id": 31605,
      "name": "怀化市",
      "provinceId": 316
    },
    31808: {
      "id": 31808,
      "name": "泰州市",
      "provinceId": 318
    },
    30704: {
      "id": 30704,
      "name": "甘南藏族自治州",
      "provinceId": 307
    },
    31210: {
      "id": 31210,
      "name": "唐山市",
      "provinceId": 312
    },
    31614: {
      "id": 31614,
      "name": "长沙市",
      "provinceId": 316
    },
    30803: {
      "id": 30803,
      "name": "东莞市",
      "provinceId": 308
    },
    30705: {
      "id": 30705,
      "name": "嘉峪关市",
      "provinceId": 307
    },
    31110: {
      "id": 31110,
      "name": "乐东黎族自治县",
      "provinceId": 311
    },
    31810: {
      "id": 31810,
      "name": "宿迁市",
      "provinceId": 318
    },
    32305: {
      "id": 32305,
      "name": "海南藏族自治州",
      "provinceId": 323
    },
    30806: {
      "id": 30806,
      "name": "河源市",
      "provinceId": 308
    },
    32202: {
      "id": 32202,
      "name": "固原市",
      "provinceId": 322
    },
    32416: {
      "id": 32416,
      "name": "烟台市",
      "provinceId": 324
    },
    30301: {
      "id": 30301,
      "name": "天津",
      "provinceId": 303
    },
    31312: {
      "id": 31312,
      "name": "三门峡市",
      "provinceId": 313
    },
    30510: {
      "id": 30510,
      "name": "淮南市",
      "provinceId": 305
    },
    33409: {
      "id": 33409,
      "name": "新竹市",
      "provinceId": 334
    },
    30915: {
      "id": 30915,
      "name": "玉林市",
      "provinceId": 309
    },
    30608: {
      "id": 30608,
      "name": "三明市",
      "provinceId": 306
    },
    32909: {
      "id": 32909,
      "name": "哈密地区",
      "provinceId": 329
    },
    31319: {
      "id": 31319,
      "name": "驻马店市",
      "provinceId": 313
    },
    31901: {
      "id": 31901,
      "name": "江西其他",
      "provinceId": 319
    },
    31309: {
      "id": 31309,
      "name": "南阳市",
      "provinceId": 313
    },
    33111: {
      "id": 33111,
      "name": "温州市",
      "provinceId": 331
    },
    31908: {
      "id": 31908,
      "name": "萍乡市",
      "provinceId": 319
    },
    30910: {
      "id": 30910,
      "name": "来宾市",
      "provinceId": 309
    },
    32103: {
      "id": 32103,
      "name": "巴彦淖尔市",
      "provinceId": 321
    },
    31710: {
      "id": 31710,
      "name": "长春市",
      "provinceId": 317
    },
    32402: {
      "id": 32402,
      "name": "滨州市",
      "provinceId": 324
    },
    31912: {
      "id": 31912,
      "name": "鹰潭市",
      "provinceId": 319
    },
    31209: {
      "id": 31209,
      "name": "石家庄市",
      "provinceId": 312
    },
    32010: {
      "id": 32010,
      "name": "锦州市",
      "provinceId": 320
    },
    32710: {
      "id": 32710,
      "name": "乐山市",
      "provinceId": 327
    },
    32701: {
      "id": 32701,
      "name": "四川其他",
      "provinceId": 327
    },
    31514: {
      "id": 31514,
      "name": "仙桃市",
      "provinceId": 315
    },
    31117: {
      "id": 31117,
      "name": "屯昌县",
      "provinceId": 311
    },
    32717: {
      "id": 32717,
      "name": "攀枝花市",
      "provinceId": 327
    },
    31003: {
      "id": 31003,
      "name": "毕节市",
      "provinceId": 310
    },
    32011: {
      "id": 32011,
      "name": "辽阳市",
      "provinceId": 320
    },
    31516: {
      "id": 31516,
      "name": "襄阳市",
      "provinceId": 315
    },
    32502: {
      "id": 32502,
      "name": "大同市",
      "provinceId": 325
    },
    31305: {
      "id": 31305,
      "name": "焦作市",
      "provinceId": 313
    },
    32110: {
      "id": 32110,
      "name": "乌海市",
      "provinceId": 321
    },
    33009: {
      "id": 33009,
      "name": "丽江市",
      "provinceId": 330
    },
    33407: {
      "id": 33407,
      "name": "台中市",
      "provinceId": 334
    },
    31505: {
      "id": 31505,
      "name": "黄石市",
      "provinceId": 315
    },
    31411: {
      "id": 31411,
      "name": "齐齐哈尔市",
      "provinceId": 314
    },
    30401: {
      "id": 30401,
      "name": "重庆",
      "provinceId": 304
    },
    32905: {
      "id": 32905,
      "name": "阿勒泰地区",
      "provinceId": 329
    },
    32407: {
      "id": 32407,
      "name": "济宁市",
      "provinceId": 324
    },
    33101: {
      "id": 33101,
      "name": "浙江其他",
      "provinceId": 331
    },
    33110: {
      "id": 33110,
      "name": "台州市",
      "provinceId": 331
    },
    32912: {
      "id": 32912,
      "name": "克拉玛依市",
      "provinceId": 329
    },
    30809: {
      "id": 30809,
      "name": "揭阳市",
      "provinceId": 308
    },
    31302: {
      "id": 31302,
      "name": "安阳市",
      "provinceId": 313
    },
    31404: {
      "id": 31404,
      "name": "哈尔滨市",
      "provinceId": 314
    },
    32918: {
      "id": 32918,
      "name": "伊犁哈萨克自治州",
      "provinceId": 329
    },
    32417: {
      "id": 32417,
      "name": "枣庄市",
      "provinceId": 324
    },
    31606: {
      "id": 31606,
      "name": "娄底市",
      "provinceId": 316
    },
    30907: {
      "id": 30907,
      "name": "桂林市",
      "provinceId": 309
    },
    32304: {
      "id": 32304,
      "name": "海东地区",
      "provinceId": 323
    },
    30817: {
      "id": 30817,
      "name": "阳江市",
      "provinceId": 308
    },
    32803: {
      "id": 32803,
      "name": "昌都地区",
      "provinceId": 328
    },
    32711: {
      "id": 32711,
      "name": "凉山彝族自治州",
      "provinceId": 327
    },
    31202: {
      "id": 31202,
      "name": "保定市",
      "provinceId": 312
    },
    32113: {
      "id": 32113,
      "name": "兴安盟",
      "provinceId": 321
    },
    32012: {
      "id": 32012,
      "name": "盘锦市",
      "provinceId": 320
    },
    32606: {
      "id": 32606,
      "name": "铜川市",
      "provinceId": 326
    },
    32002: {
      "id": 32002,
      "name": "鞍山市",
      "provinceId": 320
    },
    31121: {
      "id": 31121,
      "name": "洋浦经济开发区",
      "provinceId": 311
    },
    31613: {
      "id": 31613,
      "name": "张家界市",
      "provinceId": 316
    },
    30909: {
      "id": 30909,
      "name": "贺州市",
      "provinceId": 309
    },
    33017: {
      "id": 33017,
      "name": "昭通市",
      "provinceId": 330
    },
    31909: {
      "id": 31909,
      "name": "上饶市",
      "provinceId": 319
    },
    31107: {
      "id": 31107,
      "name": "定安县",
      "provinceId": 311
    },
    30904: {
      "id": 30904,
      "name": "崇左市",
      "provinceId": 309
    },
    32716: {
      "id": 32716,
      "name": "内江市",
      "provinceId": 327
    },
    30708: {
      "id": 30708,
      "name": "兰州市",
      "provinceId": 307
    },
    31902: {
      "id": 31902,
      "name": "抚州市",
      "provinceId": 319
    },
    30715: {
      "id": 30715,
      "name": "张掖市",
      "provinceId": 307
    },
    32306: {
      "id": 32306,
      "name": "海西蒙古族藏族自治州",
      "provinceId": 323
    },
    31707: {
      "id": 31707,
      "name": "松原市",
      "provinceId": 317
    },
    31006: {
      "id": 31006,
      "name": "黔东南苗族侗族自治州",
      "provinceId": 310
    },
    32503: {
      "id": 32503,
      "name": "晋城市",
      "provinceId": 325
    },
    31116: {
      "id": 31116,
      "name": "三亚市",
      "provinceId": 311
    },
    30501: {
      "id": 30501,
      "name": "安徽其他",
      "provinceId": 305
    },
    32102: {
      "id": 32102,
      "name": "阿拉善盟",
      "provinceId": 321
    },
    33003: {
      "id": 33003,
      "name": "楚雄彝族自治州",
      "provinceId": 330
    },
    31313: {
      "id": 31313,
      "name": "商丘市",
      "provinceId": 313
    },
    32802: {
      "id": 32802,
      "name": "阿里地区",
      "provinceId": 328
    },
    32005: {
      "id": 32005,
      "name": "大连市",
      "provinceId": 320
    },
    31103: {
      "id": 31103,
      "name": "保亭黎族苗族自治县",
      "provinceId": 311
    },
    32911: {
      "id": 32911,
      "name": "喀什地区",
      "provinceId": 329
    },
    30515: {
      "id": 30515,
      "name": "芜湖市",
      "provinceId": 305
    },
    32418: {
      "id": 32418,
      "name": "淄博市",
      "provinceId": 324
    },
    31608: {
      "id": 31608,
      "name": "湘潭市",
      "provinceId": 316
    },
    30508: {
      "id": 30508,
      "name": "合肥市",
      "provinceId": 305
    },
    30101: {
      "id": 30101,
      "name": "北京",
      "provinceId": 301
    },
    31308: {
      "id": 31308,
      "name": "漯河市",
      "provinceId": 313
    },
    33408: {
      "id": 33408,
      "name": "新北市",
      "provinceId": 334
    },
    31910: {
      "id": 31910,
      "name": "新余市",
      "provinceId": 319
    },
    33010: {
      "id": 33010,
      "name": "临沧市",
      "provinceId": 330
    },
    32702: {
      "id": 32702,
      "name": "阿坝藏族羌族自治州",
      "provinceId": 327
    },
    32605: {
      "id": 32605,
      "name": "商洛市",
      "provinceId": 326
    },
    32206: {
      "id": 32206,
      "name": "中卫市",
      "provinceId": 322
    },
    31809: {
      "id": 31809,
      "name": "无锡市",
      "provinceId": 318
    },
    33011: {
      "id": 33011,
      "name": "怒江傈僳族自治州",
      "provinceId": 330
    },
    32508: {
      "id": 32508,
      "name": "太原市",
      "provinceId": 325
    },
    30507: {
      "id": 30507,
      "name": "阜阳市",
      "provinceId": 305
    },
    30818: {
      "id": 30818,
      "name": "云浮市",
      "provinceId": 308
    },
    33002: {
      "id": 33002,
      "name": "保山市",
      "provinceId": 330
    },
    33016: {
      "id": 33016,
      "name": "玉溪市",
      "provinceId": 330
    },
    31401: {
      "id": 31401,
      "name": "黑龙江其他",
      "provinceId": 314
    },
    31607: {
      "id": 31607,
      "name": "邵阳市",
      "provinceId": 316
    },
    30707: {
      "id": 30707,
      "name": "酒泉市",
      "provinceId": 307
    },
    31410: {
      "id": 31410,
      "name": "七台河市",
      "provinceId": 314
    },
    32906: {
      "id": 32906,
      "name": "巴音郭楞蒙古自治州",
      "provinceId": 329
    },
    32108: {
      "id": 32108,
      "name": "呼伦贝尔市",
      "provinceId": 321
    },
    31806: {
      "id": 31806,
      "name": "南通市",
      "provinceId": 318
    },
    32013: {
      "id": 32013,
      "name": "沈阳市",
      "provinceId": 320
    },
    32112: {
      "id": 32112,
      "name": "锡林郭勒盟",
      "provinceId": 321
    },
    33106: {
      "id": 33106,
      "name": "丽水市",
      "provinceId": 331
    },
    33303: {
      "id": 33303,
      "name": "澳门离岛",
      "provinceId": 333
    },
    32307: {
      "id": 32307,
      "name": "黄南藏族自治州",
      "provinceId": 323
    },
    32501: {
      "id": 32501,
      "name": "山西其他",
      "provinceId": 325
    },
    30912: {
      "id": 30912,
      "name": "南宁市",
      "provinceId": 309
    },
    31115: {
      "id": 31115,
      "name": "三沙市",
      "provinceId": 311
    },
    32511: {
      "id": 32511,
      "name": "运城市",
      "provinceId": 325
    },
    30201: {
      "id": 30201,
      "name": "上海",
      "provinceId": 302
    },
    30605: {
      "id": 30605,
      "name": "宁德市",
      "provinceId": 306
    },
    30805: {
      "id": 30805,
      "name": "广州市",
      "provinceId": 308
    },
    31314: {
      "id": 31314,
      "name": "新乡市",
      "provinceId": 313
    },
    30901: {
      "id": 30901,
      "name": "广西其他",
      "provinceId": 309
    },
    33501: {
      "id": 33501,
      "name": "海外",
      "provinceId": 335
    }
  },
  "baseIndustryIds": [101, 102, 103, 105, 106, 111, 110, 109, 108, 107, 999],
  "positionHotcitys": [{
    "code": "30101",
    "count": 1040,
    "name": "北京",
    "subs": []
  }, {
    "code": "30201",
    "count": 576,
    "name": "上海",
    "subs": []
  }, {
    "code": "30805",
    "count": 198,
    "name": "广州市",
    "subs": []
  }, {
    "code": "30816",
    "count": 837,
    "name": "深圳市",
    "subs": []
  }, {
    "code": "33102",
    "count": 756,
    "name": "杭州市",
    "subs": []
  }, {
    "code": "31513",
    "count": 19,
    "name": "武汉市",
    "subs": []
  }, {
    "code": "32704",
    "count": 38,
    "name": "成都市",
    "subs": []
  }, {
    "code": "30401",
    "count": 6,
    "name": "重庆",
    "subs": []
  }, {
    "code": "30609",
    "count": 4,
    "name": "厦门市",
    "subs": []
  }, {
    "code": "31807",
    "count": 17,
    "name": "苏州市",
    "subs": []
  }, {
    "code": "308",
    "count": 17,
    "name": "广东",
    "subs": []
  }, {
    "code": "331",
    "count": 17,
    "name": "浙江",
    "subs": []
  }, {
    "code": "30803",
    "count": 35,
    "name": "东莞市",
    "subs": []
  }, {
    "code": "31805",
    "count": 32,
    "name": "南京市",
    "subs": []
  }, {
    "code": "30301",
    "count": 23,
    "name": "天津",
    "subs": []
  }, {
    "code": "30602",
    "count": 21,
    "name": "福州市",
    "subs": []
  }, {
    "code": "33107",
    "count": 16,
    "name": "宁波市",
    "subs": []
  }, {
    "code": "31614",
    "count": 15,
    "name": "长沙市",
    "subs": []
  }, {
    "code": "32406",
    "count": 12,
    "name": "济南市",
    "subs": []
  }, {
    "code": "30804",
    "count": 11,
    "name": "佛山市",
    "subs": []
  }, {
    "code": "31317",
    "count": 10,
    "name": "郑州市",
    "subs": []
  }, {
    "code": "30607",
    "count": 9,
    "name": "泉州市",
    "subs": []
  }, {
    "code": "31809",
    "count": 8,
    "name": "无锡市",
    "subs": []
  }, {
    "code": "30807",
    "count": 7,
    "name": "惠州市",
    "subs": []
  }, {
    "code": "32411",
    "count": 7,
    "name": "青岛市",
    "subs": []
  }, {
    "code": "31210",
    "count": 5,
    "name": "唐山市",
    "subs": []
  }, {
    "code": "31903",
    "count": 5,
    "name": "赣州市",
    "subs": []
  }, {
    "code": "33501",
    "count": 9,
    "name": "海外",
    "subs": []
  }],
  "province": [{
    "citys": [30101],
    "id": 301,
    "name": "北京"
  }, {
    "citys": [30201],
    "id": 302,
    "name": "上海"
  }, {
    "citys": [30301],
    "id": 303,
    "name": "天津"
  }, {
    "citys": [30401],
    "id": 304,
    "name": "重庆"
  }, {
    "citys": [30502, 30503, 30504, 30505, 30506, 30507, 30508, 30509, 30510, 30511, 30512, 30513, 30514, 30515, 30516, 30501],
    "id": 305,
    "name": "安徽省"
  }, {
    "citys": [30602, 30603, 30604, 30605, 30606, 30607, 30608, 30609, 30610, 30601],
    "id": 306,
    "name": "福建省"
  }, {
    "citys": [30702, 30703, 30704, 30705, 30706, 30707, 30708, 30709, 30710, 30711, 30712, 30713, 30714, 30715, 30701],
    "id": 307,
    "name": "甘肃省"
  }, {
    "citys": [30802, 30803, 30804, 30805, 30806, 30807, 30808, 30809, 30810, 30811, 30812, 30813, 30814, 30815, 30816, 30817, 30818, 30819, 30820, 30821, 30822, 30801],
    "id": 308,
    "name": "广东省"
  }, {
    "citys": [30902, 30903, 30904, 30905, 30906, 30907, 30908, 30909, 30910, 30911, 30912, 30913, 30914, 30915, 30901],
    "id": 309,
    "name": "广西省"
  }, {
    "citys": [31002, 31003, 31004, 31005, 31006, 31007, 31008, 31009, 31010, 31001],
    "id": 310,
    "name": "贵州省"
  }, {
    "citys": [31102, 31103, 31104, 31105, 31106, 31107, 31108, 31109, 31110, 31111, 31112, 31113, 31114, 31115, 31116, 31117, 31118, 31119, 31120, 31121, 31101],
    "id": 311,
    "name": "海南省"
  }, {
    "citys": [31202, 31203, 31204, 31205, 31206, 31207, 31208, 31209, 31210, 31211, 31212, 31201],
    "id": 312,
    "name": "河北省"
  }, {
    "citys": [31302, 31303, 31304, 31305, 31306, 31307, 31308, 31309, 31310, 31311, 31312, 31313, 31314, 31315, 31316, 31317, 31318, 31319, 31301],
    "id": 313,
    "name": "河南省"
  }, {
    "citys": [31402, 31403, 31404, 31405, 31406, 31407, 31408, 31409, 31410, 31411, 31412, 31413, 31414, 31401],
    "id": 314,
    "name": "黑龙江省"
  }, {
    "citys": [31502, 31503, 31504, 31505, 31506, 31507, 31508, 31509, 31510, 31511, 31512, 31513, 31514, 31515, 31516, 31517, 31518, 31501],
    "id": 315,
    "name": "湖北省"
  }, {
    "citys": [31602, 31603, 31604, 31605, 31606, 31607, 31608, 31609, 31610, 31611, 31612, 31613, 31614, 31615, 31601],
    "id": 316,
    "name": "湖南省"
  }, {
    "citys": [31702, 31703, 31704, 31705, 31706, 31707, 31708, 31709, 31710, 31701],
    "id": 317,
    "name": "吉林省"
  }, {
    "citys": [31802, 31803, 31804, 31805, 31806, 31807, 31808, 31809, 31810, 31811, 31812, 31813, 31814, 31801],
    "id": 318,
    "name": "江苏省"
  }, {
    "citys": [31902, 31903, 31904, 31905, 31906, 31907, 31908, 31909, 31910, 31911, 31912, 31901],
    "id": 319,
    "name": "江西省"
  }, {
    "citys": [32002, 32003, 32004, 32005, 32006, 32007, 32008, 32009, 32010, 32011, 32012, 32013, 32014, 32015, 32001],
    "id": 320,
    "name": "辽宁省"
  }, {
    "citys": [32102, 32103, 32104, 32105, 32106, 32107, 32108, 32109, 32110, 32111, 32112, 32113, 32101],
    "id": 321,
    "name": "内蒙古"
  }, {
    "citys": [32202, 32203, 32204, 32205, 32206, 32201],
    "id": 322,
    "name": "宁夏"
  }, {
    "citys": [32302, 32303, 32304, 32305, 32306, 32307, 32308, 32309, 32301],
    "id": 323,
    "name": "青海省"
  }, {
    "citys": [32402, 32403, 32404, 32405, 32406, 32407, 32408, 32409, 32410, 32411, 32412, 32413, 32414, 32415, 32416, 32417, 32418, 32401],
    "id": 324,
    "name": "山东省"
  }, {
    "citys": [32502, 32503, 32504, 32505, 32506, 32507, 32508, 32509, 32510, 32511, 32512, 32501],
    "id": 325,
    "name": "山西省"
  }, {
    "citys": [32602, 32603, 32604, 32605, 32606, 32607, 32608, 32609, 32610, 32611, 32601],
    "id": 326,
    "name": "陕西省"
  }, {
    "citys": [32702, 32703, 32704, 32705, 32706, 32707, 32708, 32709, 32710, 32711, 32712, 32713, 32714, 32715, 32716, 32717, 32718, 32719, 32720, 32721, 32722, 32701],
    "id": 327,
    "name": "四川省"
  }, {
    "citys": [32802, 32803, 32804, 32805, 32806, 32807, 32808, 32801],
    "id": 328,
    "name": "西藏"
  }, {
    "citys": [32902, 32903, 32904, 32905, 32906, 32907, 32908, 32909, 32910, 32911, 32912, 32913, 32914, 32915, 32916, 32917, 32918, 32901],
    "id": 329,
    "name": "新疆"
  }, {
    "citys": [33002, 33003, 33004, 33005, 33006, 33007, 33008, 33009, 33010, 33011, 33012, 33013, 33014, 33015, 33016, 33017, 33001],
    "id": 330,
    "name": "云南省"
  }, {
    "citys": [33102, 33103, 33104, 33105, 33106, 33107, 33108, 33109, 33110, 33111, 33112, 33101],
    "id": 331,
    "name": "浙江省"
  }, {
    "citys": [33201, 33202, 33203, 33204],
    "id": 332,
    "name": "香港"
  }, {
    "citys": [33301, 33302, 33303],
    "id": 333,
    "name": "澳门"
  }, {
    "citys": [33401, 33402, 33403, 33404, 33405, 33406, 33407, 33408, 33409],
    "id": 334,
    "name": "台湾"
  }, {
    "citys": [33501],
    "id": 335,
    "name": "海外"
  }],
  "industry": {
    107002: {
      "displayName": "机械/重工",
      "id": 107002,
      "name": "机械/重工",
      "nextLevelIds": [],
      "parentId": 107
    },
    108005: {
      "displayName": "专业服务（法律/会计/翻译等）",
      "id": 108005,
      "name": "专业服务（法律/会计/翻译等）",
      "nextLevelIds": [],
      "parentId": 108
    },
    106002: {
      "displayName": "医疗设备/器械",
      "id": 106002,
      "name": "医疗设备/器械",
      "nextLevelIds": [],
      "parentId": 106
    },
    107999: {
      "displayName": "其他",
      "id": 107999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 107
    },
    111004: {
      "displayName": "新能源/环保",
      "id": 111004,
      "name": "新能源/环保",
      "nextLevelIds": [],
      "parentId": 111
    },
    103: {
      "displayName": "房地产",
      "id": 103,
      "name": "房地产",
      "nextLevelIds": [103001, 103999],
      "parentId": 0
    },
    111003: {
      "displayName": "能源/水利",
      "id": 111003,
      "name": "能源/水利",
      "nextLevelIds": [],
      "parentId": 111
    },
    110: {
      "displayName": "广告·媒体·教育",
      "id": 110,
      "name": "广告·媒体·教育",
      "nextLevelIds": [110003, 110002, 110001, 110004, 110999],
      "parentId": 0
    },
    999: {
      "displayName": "其他",
      "id": 999,
      "name": "其他",
      "nextLevelIds": [999999],
      "parentId": 0
    },
    107001: {
      "displayName": "汽车/零配件",
      "id": 107001,
      "name": "汽车/零配件",
      "nextLevelIds": [],
      "parentId": 107
    },
    107006: {
      "displayName": "原材料/模具加工制造",
      "id": 107006,
      "name": "原材料/模具加工制造",
      "nextLevelIds": [],
      "parentId": 107
    },
    102006: {
      "displayName": "PE/VC",
      "id": 102006,
      "name": "PE/VC",
      "nextLevelIds": [],
      "parentId": 102
    },
    111002: {
      "displayName": "采掘/冶炼",
      "id": 111002,
      "name": "采掘/冶炼",
      "nextLevelIds": [],
      "parentId": 111
    },
    106999: {
      "displayName": "其他",
      "id": 106999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 106
    },
    111: {
      "displayName": "能源·化工·环保",
      "id": 111,
      "name": "能源·化工·环保",
      "nextLevelIds": [111999, 111001, 111002, 111003, 111004, 111005],
      "parentId": 0
    },
    101006: {
      "displayName": "电子/半导体",
      "id": 101006,
      "name": "电子/半导体",
      "nextLevelIds": [],
      "parentId": 101
    },
    101999: {
      "displayName": "其他",
      "id": 101999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 101
    },
    108002: {
      "displayName": "酒店旅游业",
      "id": 108002,
      "name": "酒店旅游业",
      "nextLevelIds": [],
      "parentId": 108
    },
    109001: {
      "displayName": "物流仓储",
      "id": 109001,
      "name": "物流仓储",
      "nextLevelIds": [],
      "parentId": 109
    },
    101005: {
      "displayName": "通信/网络设备",
      "id": 101005,
      "name": "通信/网络设备",
      "nextLevelIds": [],
      "parentId": 101
    },
    102: {
      "displayName": "金融",
      "id": 102,
      "name": "金融",
      "nextLevelIds": [102002, 102003, 102001, 102006, 102004, 102005, 102999],
      "parentId": 0
    },
    108003: {
      "displayName": "休闲/娱乐/健身",
      "id": 108003,
      "name": "休闲/娱乐/健身",
      "nextLevelIds": [],
      "parentId": 108
    },
    101: {
      "displayName": "IT·互联网",
      "id": 101,
      "name": "IT·互联网",
      "nextLevelIds": [101999, 101004, 101005, 101006, 101001, 101002, 101003],
      "parentId": 0
    },
    108001: {
      "displayName": "餐饮业",
      "id": 108001,
      "name": "餐饮业",
      "nextLevelIds": [],
      "parentId": 108
    },
    108: {
      "displayName": "服务业",
      "id": 108,
      "name": "服务业",
      "nextLevelIds": [108999, 108004, 108005, 108002, 108003, 108001],
      "parentId": 0
    },
    110003: {
      "displayName": "教育培训",
      "id": 110003,
      "name": "教育培训",
      "nextLevelIds": [],
      "parentId": 110
    },
    108999: {
      "displayName": "其他",
      "id": 108999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 108
    },
    102002: {
      "displayName": "银行",
      "id": 102002,
      "name": "银行",
      "nextLevelIds": [],
      "parentId": 102
    },
    999999: {
      "displayName": "其他",
      "id": 999999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 999
    },
    110001: {
      "displayName": "广告会展",
      "id": 110001,
      "name": "广告会展",
      "nextLevelIds": [],
      "parentId": 110
    },
    111001: {
      "displayName": "石油/化工",
      "id": 111001,
      "name": "石油/化工",
      "nextLevelIds": [],
      "parentId": 111
    },
    109: {
      "displayName": "物流·贸易",
      "id": 109,
      "name": "物流·贸易",
      "nextLevelIds": [109001, 109002, 109999],
      "parentId": 0
    },
    101003: {
      "displayName": "计算机软件",
      "id": 101003,
      "name": "计算机软件",
      "nextLevelIds": [],
      "parentId": 101
    },
    107003: {
      "displayName": "印刷/包装/造纸",
      "id": 107003,
      "name": "印刷/包装/造纸",
      "nextLevelIds": [],
      "parentId": 107
    },
    110004: {
      "displayName": "科研艺术",
      "id": 110004,
      "name": "科研艺术",
      "nextLevelIds": [],
      "parentId": 110
    },
    111999: {
      "displayName": "其他",
      "id": 111999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 111
    },
    102001: {
      "displayName": "互联网金融",
      "id": 102001,
      "name": "互联网金融",
      "nextLevelIds": [],
      "parentId": 102
    },
    109999: {
      "displayName": "其他",
      "id": 109999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 109
    },
    101004: {
      "displayName": "智能硬件",
      "id": 101004,
      "name": "智能硬件",
      "nextLevelIds": [],
      "parentId": 101
    },
    109002: {
      "displayName": "进出口贸易",
      "id": 109002,
      "name": "进出口贸易",
      "nextLevelIds": [],
      "parentId": 109
    },
    102003: {
      "displayName": "保险",
      "id": 102003,
      "name": "保险",
      "nextLevelIds": [],
      "parentId": 102
    },
    110999: {
      "displayName": "其他",
      "id": 110999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 110
    },
    107: {
      "displayName": "汽车·机械·制造",
      "id": 107,
      "name": "汽车·机械·制造",
      "nextLevelIds": [107006, 107005, 107004, 107003, 107002, 107001, 107999],
      "parentId": 0
    },
    108004: {
      "displayName": "美容保健",
      "id": 108004,
      "name": "美容保健",
      "nextLevelIds": [],
      "parentId": 108
    },
    106: {
      "displayName": "医疗·制药",
      "id": 106,
      "name": "医疗·制药",
      "nextLevelIds": [106999, 106001, 106003, 106002],
      "parentId": 0
    },
    103001: {
      "displayName": "房地产",
      "id": 103001,
      "name": "房地产",
      "nextLevelIds": [],
      "parentId": 103
    },
    107005: {
      "displayName": "航天/航空研究与制造",
      "id": 107005,
      "name": "航天/航空研究与制造",
      "nextLevelIds": [],
      "parentId": 107
    },
    101002: {
      "displayName": "网络游戏",
      "id": 101002,
      "name": "网络游戏",
      "nextLevelIds": [],
      "parentId": 101
    },
    102004: {
      "displayName": "证券/基金/期货",
      "id": 102004,
      "name": "证券/基金/期货",
      "nextLevelIds": [],
      "parentId": 102
    },
    105999: {
      "displayName": "其他",
      "id": 105999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 105
    },
    105: {
      "displayName": "快消品",
      "id": 105,
      "name": "快消品",
      "nextLevelIds": [105002, 105001, 105999],
      "parentId": 0
    },
    110002: {
      "displayName": "影视文化",
      "id": 110002,
      "name": "影视文化",
      "nextLevelIds": [],
      "parentId": 110
    },
    105001: {
      "displayName": "快消品",
      "id": 105001,
      "name": "快消品",
      "nextLevelIds": [],
      "parentId": 105
    },
    102999: {
      "displayName": "其他",
      "id": 102999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 102
    },
    106003: {
      "displayName": "医疗/医美/护理",
      "id": 106003,
      "name": "医疗/医美/护理",
      "nextLevelIds": [],
      "parentId": 106
    },
    106001: {
      "displayName": "制药/生物工程",
      "id": 106001,
      "name": "制药/生物工程",
      "nextLevelIds": [],
      "parentId": 106
    },
    101001: {
      "displayName": "互联网",
      "id": 101001,
      "name": "互联网",
      "nextLevelIds": [],
      "parentId": 101
    },
    103999: {
      "displayName": "其他",
      "id": 103999,
      "name": "其他",
      "nextLevelIds": [],
      "parentId": 103
    },
    107004: {
      "displayName": "仪表/仪器/工业自动化",
      "id": 107004,
      "name": "仪表/仪器/工业自动化",
      "nextLevelIds": [],
      "parentId": 107
    },
    105002: {
      "displayName": "耐消品",
      "id": 105002,
      "name": "耐消品",
      "nextLevelIds": [],
      "parentId": 105
    },
    102005: {
      "displayName": "信托/担保/拍卖/典当",
      "id": 102005,
      "name": "信托/担保/拍卖/典当",
      "nextLevelIds": [],
      "parentId": 102
    },
    111005: {
      "displayName": "原材料加工",
      "id": 111005,
      "name": "原材料加工",
      "nextLevelIds": [],
      "parentId": 111
    }
  },
}


//公司规模
window.METADATA.companySize = [
  {
    id: 1,
    value: '1-49人'
  },
  {
    id: 2,
    value: '50-99人'
  },
  {
    id: 3,
    value: '100-499人'
  },
  {
    id: 4,
    value: '500-999人'
  },
  {
    id: 5,
    value: '1000-4999人'
  },
  {
    id: 6,
    value: '5000-9999人'
  },
  {
    id: 7,
    value: '10000人以上'
  }
];
//面试轮次
window.METADATA.interviewTimesObj = {
  1: "一轮",
  2: "二轮",
  3: "三轮",
  4: "四轮",
  5: "五轮",
  6: "六轮"
};
//面试方法
window.METADATA.interviewTypeObj = {
  1: "面谈",
  2: "笔试",
  3: "机试",
  4: "电话面试",
  5: "视频面试"
};

//订单状态
window.METADATA.allCandidateStatus = {
  // 1新建待审核
  '1': 'LEADER审核中',
  // 2打回待审核
  '2': 'Leader推荐打回',
  // 3猎上拒绝
  '3': 'PA推荐打回',
  // 4待猎上审核
  '4': '推荐中',
  // 5新推
  '5': '推荐中',
  // 6已阅
  '6': '评估中',
  // 7简历待定
  '7': '评估通过',
  // 8面试前拒绝
  '8': '评估未通过',
  // 9面试前撤销（终止）
  '9': '面试前撤销',
  // 10申请面试
  '10': '面试待确认',
  // 11确认面试，面试中
  '11': '面试确认',
  // 12取消面试
  '12': '面试取消',
  // 13面试后拒绝
  '13': '面试未通过',
  // 14面试后撤销（终止）
  '14': '面试后撤销',
  // 15offer ，未到岗
  '15': 'Offer',
  // 16放弃到岗
  '16': '放弃到岗',
  // 17已到岗，未过保
  '17': '已到岗',
  // 18过保（终止）
  '18': '过保',
  // 19面试到达
  '19': '面试到达',
  // 20放弃面试
  '20': '放弃面试',
  // 21候选人放弃推荐
  '21': '放弃推荐',
  //22离岗
  '22': '未过保',
  //23 面试待定
  '23': '面试通过',
  // 24 hr打回
  '24': '推荐打回'
};
// 求职状态
window.METADATA.applyJobStatusMap = {
  1: '在职，看看新机会',
  2: '在职，急寻新工作',
  3: '在职，暂无跳槽打算',
  4: '离职，正在找工作'
};
//是否统招
window.METADATA.recruitmentStatus = {
  1: "统招",
  2: "非统招"
};

window.METADATA.overSeasNum = {
  '+1': '美国',
  '+852': '中国香港',
  '+886': '中国台湾地区',
  '+65': '新加坡',
  '+81': '日本',
  '+82': '韩国',
  '+60': '马来西亚',
  '+86': '中国'
};